import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { CarrierRepository } from '../infra/CarrierRepository'

export type GetCarrierEmployeesDependencies = {
  repository: CarrierRepository
}

export function getCarrierEmployeesFactory({ repository }: GetCarrierEmployeesDependencies) {
  return async function getCarrierEmployeesByUUID(
    carrierUUID: string,
    config?: { signal?: AbortSignal }
  ) {
    try {
      return await repository.getCarrierEmployees(carrierUUID, config)
    } catch (error) {
      throw new Error('Failed to get employees', { cause: error as Error })
    }
  }
}

export function getCarrierEmployees(carrierUUID: string, config?: { signal: AbortSignal }) {
  const httpClient = createAgnosticHttpClient()
  const repository = new CarrierRepository({ httpClient })
  const getEmployees = getCarrierEmployeesFactory({ repository })

  return getEmployees(carrierUUID, config)
}
